// axios
import axios from 'axios'
import { getUserData } from '@/auth/utils'

const api = axios.create({
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    'Access-Control-Allow-Origin': '*'
  },
  withCredentials: true
})

api.interceptors.request.use(config => {
  const userData = getUserData()
  if (userData) {
    if (config.data) {
      config.data.login = userData.user?.login
      config.data.token = userData.token_auth
    } else {
      config.data = { login: userData.user?.login, token: userData.token_auth }
    }
  }
  return config
})

export default api
